import { ZIP_REGEX } from "./constants/validationPatterns";

export const isValidZipcode = (zip: string | undefined): boolean => {
  if (zip) {
    return ZIP_REGEX.test(zip);
  }
  return false;
};
